var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification"},[_c('div',{staticClass:"gesture",class:[("gesture" + _vm.num), _vm.ani]}),_c('div',{staticClass:"t-container"},[_c('img',{staticClass:"t-desc",attrs:{"src":_vm.imgSrc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }